import { combineReducers } from 'redux';
import { commonSearchReducer, tourSearchReducer } from '@state/slices/search';

export const combinedSearchReducers = combineReducers({
  tours: tourSearchReducer,
  common: commonSearchReducer
});
